import type {AiFeatureType} from 'nutshell-graphql-types';

export type AiFeature = {
    type: AiFeatureType;
    name: string;
    icon: React.ComponentType<any>;
    grouping: AiFeatureGrouping;
    cardDescription: string;
    pathSegment: string;
    cardIllustration?: string;
    pageDescription: string;
    pageIllustration: string;
    highlights: {
        icon: React.ComponentType<any>;
        title: string;
        description: string;
    }[];
    hasNoStats?: boolean; // Whether the feature has query stats implemented on the backend,
    video?: string;
    learnMoreLink?: string;
    otherFeatures: AiFeatureType[]; // Should be type of feature
};

export type AiFeatureGrouping =
    | 'assistants'
    | 'salesAcceleration'
    | 'notetakers'
    | 'marketing'
    | 'reporting'
    | 'other';

export type TabOption = AiFeatureGrouping | 'all';

export type TryItFeature =
    | 'AI_FOLLOW_UP_TASKS'
    | 'LEAD_RESEARCHER'
    | 'EMAIL_SEQUENCE_WRITER'
    | 'SALES_OBJECTION_COACH'
    | 'SALES_PIPELINE_DESIGNER'
    | 'GOOGLE_MEET_NOTETAKER'
    | 'ZOOM_NOTETAKER'
    | 'MICROSOFT_TEAMS_NOTETAKER'
    | 'CLICK_TO_CALL_NOTETAKER'
    | 'RINGCENTRAL_NOTETAKER'
    | 'AIRCALL_NOTETAKER'
    | 'DIALPAD_NOTETAKER'
    | 'CALLRAIL_NOTETAKER'
    | 'KIXIE_NOTETAKER'
    | 'EMAIL_CAMPAIGN_BUILDER'
    | 'COMPANY_IQ'
    | 'PEOPLE_IQ'
    | 'VISITOR_IQ'
    | 'PROSPECTOR_IQ'
    | 'COMPETITOR_SPY'
    | 'SALES_CHATBOT';

export const TRY_IT_FEATURES: TryItFeature[] = [
    'AI_FOLLOW_UP_TASKS',
    'LEAD_RESEARCHER',
    'EMAIL_SEQUENCE_WRITER',
    'SALES_OBJECTION_COACH',
    'SALES_PIPELINE_DESIGNER',
    'GOOGLE_MEET_NOTETAKER',
    'ZOOM_NOTETAKER',
    'MICROSOFT_TEAMS_NOTETAKER',
    'CLICK_TO_CALL_NOTETAKER',
    'RINGCENTRAL_NOTETAKER',
    'AIRCALL_NOTETAKER',
    'DIALPAD_NOTETAKER',
    'CALLRAIL_NOTETAKER',
    'KIXIE_NOTETAKER',
    'EMAIL_CAMPAIGN_BUILDER',
    'COMPANY_IQ',
    'PEOPLE_IQ',
    'VISITOR_IQ',
    'PROSPECTOR_IQ',
    'COMPETITOR_SPY',
    'SALES_CHATBOT',
];
